module.exports = __webpack_public_path__ + "img/model-x-attention-to-detail.c67b4a68.jpg";